var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.515 0h5.544v29h-5.544z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 17.272v-5.544h29v5.544z"
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTEuNTE0NiIgd2lkdGg9IjUuNTQ0MTIiIGhlaWdodD0iMjkiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHk9IjE3LjI3MjEiIHdpZHRoPSI1LjU0NDEyIiBoZWlnaHQ9IjI5IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgMCAxNy4yNzIxKSIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";